import { render } from "./PromoBranchRow.vue?vue&type=template&id=3e9b53fc"
import script from "./PromoBranchRow.vue?vue&type=script&lang=js"
export * from "./PromoBranchRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__